import { Flex, Image, Text } from '@podiumhq/design-system';
import PropTypes from 'prop-types';

const Testimonial = ({ image, text, attribution }) => (
  <Flex maxWidth="380px" m="0 auto" alignItems="center">
    <Image src={image} w="55px" h="55px" mr="16px" borderRadius="50%" />
    <Flex flexDir="column">
      <Text fontSize="md" fontWeight="medium" lineHeight="20px">
        {text}
      </Text>
      <Text
        fontSize="md"
        fontWeight="normal"
        lineHeight="20px"
        color="grey.lighter"
        mt="8px"
      >
        {attribution}
      </Text>
    </Flex>
  </Flex>
);

Testimonial.propTypes = {
  image: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  attribution: PropTypes.string.isRequired,
};

export default Testimonial;
